export default function () {
  return [
    {name: 'Jan', earns: 4000, pv: 2400, amt: 2400},
    {name: 'Feb', earns: 3000, pv: 1398, amt: 2210},
    {name: 'Mar', earns: 2000, pv: 9800, amt: 2290},
    {name: 'Apr', earns: 2780, pv: 3908, amt: 2000},
    {name: 'May', earns: 1890, pv: 4800, amt: 2181},
    {name: 'Jun', earns: 2390, pv: 3800, amt: 2500},
    {name: 'Jul', earns: 3490, pv: 4300, amt: 2100},
  ]
}



// WEBPACK FOOTER //
// ./src/reducers/chart-reducers/chartReducers.js